import { useContext, useState } from 'react';

import { RadioButtonGroup } from '@selina-finance/ui';
import { useNavigate } from 'react-router-dom';

import { DebtConContext } from '@src/app/contexts/DebtCon';
import BackButton from '@src/ui/components/BackButton/BackButton';
import { HttpError } from '@src/ui/components/HttpError';
import ProgressMenu from '@src/ui/components/Progress/ProgressMenu';

export const mainGoalLabels = [
    'Lower my monthly payments',
    'Pay less interest overall',
    'Have single monthly payment',
    'Pay off my borrowing quicker',
    'Another reason',
];

const mainGoalOptions = mainGoalLabels.map((name) => ({
    label: name,
    value: name,
}));

const MainGoalView = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [selectedMainGoal, setSelectedMainGoal] = useState<string | null>(
        null,
    );
    const { selectMainGoal } = useContext(DebtConContext);

    const handleGoalSelection = async (selectedValue: string) => {
        if (!selectedValue) return;
        setSelectedMainGoal(selectedValue);

        const response = await selectMainGoal(selectedValue);
        if (response.success) {
            navigate('/eligibility/debt-con/borrow');
        } else {
            setError(response.error);
        }
    };

    return (
        <div className='flex flex-row justify-between'>
            <div className='flex flex-col mx-auto max-w-400 w-full mt-20 sm:mt-0 sm:mr-10 sm:ml-0'>
                <div className='hidden lg:block mb-8'>
                    <BackButton />
                </div>
                <div className='text-xl text-midnight-400'>
                    <div className='flex flex-col mb-4'>
                        <p className='text-2xl leading-100 font-sora-bold lg:text-28 tracking-tighter'>
                            What’s your main goal?
                        </p>
                        <p className='leading-6 mt-2 text-lg text-midnight-200'>
                            Choosing your goal won’t affect your eligibility for
                            a loan.
                        </p>
                    </div>
                    <RadioButtonGroup
                        small
                        className='flex-col text-body'
                        name='mainGoal'
                        id='mainGoal'
                        value={selectedMainGoal || ''}
                        onChange={(e) => handleGoalSelection(e.target.value)}
                        options={mainGoalOptions}
                    />
                </div>
                {error && <HttpError error={error} />}
            </div>
            <ProgressMenu />
        </div>
    );
};

export default MainGoalView;
